// Ported from design/project/App71-WithdrawSuccess.dc.html, then wired to follow the payout until it lands.
// While the vault is still sending, the check mark is a spinner and the title says it is on its way.
import { useEffect } from "react";
import { fit } from "../fit.js";
import { explorerTx, useMoney, useWithdrawal, walletName } from "../money.js";
import { go } from "../router.js";
import { tg } from "../telegram.js";

export function App71_WithdrawSuccess() {
  const id = sessionStorage.getItem("dd:withdrawal");
  const w = useWithdrawal(id);
  const { view } = useMoney();
  useEffect(() => {
    if (!id) go("App28", true);
    else if (w?.state === "failed") go("App56", true);
    else if (w?.state === "done") tg?.HapticFeedback?.notificationOccurred("success");
  }, [id, w?.state]);
  const sending = !w || w.state === "paying";
  const secs = w?.finishedAt ? Math.round((w.finishedAt - w.createdAt) / 1000) : null;
  const open = (url: string) => (tg?.openLink ? tg.openLink(url) : void window.open(url, "_blank"));

  return (
    <>
      <div className="screen">
  <div className="orbL" aria-hidden="true" style={{ top: "40px", left: "-45px", width: "480px", height: "480px" }}></div>
  <div className="pad squeeze" style={{ height: "100%", paddingBottom: "44px" }}>
    <div className="top"><span className="chip chipL">{sending ? "SENDING" : w.state === "partial" ? "PARTLY SENT" : "WITHDRAWAL COMPLETE"}</span></div>
    {sending ? (
      <div style={{ marginTop: fit(6, 18), alignSelf: "center", width: fit(88, 120), height: fit(88, 120) }}>
        <svg width="100%" height="100%" viewBox="0 0 120 120" style={{ display: "block", animation: "ddSpin 1.4s linear infinite" }} aria-hidden="true"><circle cx="60" cy="60" r="52" fill="none" stroke="#30363D" strokeWidth="6"></circle><path d="M60 8 A52 52 0 0 1 112 60" fill="none" stroke="#CCFF00" strokeWidth="6" strokeLinecap="round"></path></svg>
      </div>
    ) : (
      <div style={{ marginTop: fit(6, 18), alignSelf: "center", width: fit(88, 120), height: fit(88, 120), borderRadius: "50%", background: "#CCFF00", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 0 10px rgba(204,255,0,0.12), 0 0 60px rgba(204,255,0,0.45)" }}>
        <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="#0B0E14" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5 L10 17.5 L19 7"></path></svg>
      </div>
    )}
    <span className="mono lime" style={{ marginTop: fit(14, 26), alignSelf: "center", fontWeight: "800", fontSize: "40px" }}>{w?.received ?? "..."}</span>
    <h1 className="h1" style={{ marginTop: "6px", textAlign: "center" }}>{sending ? "On its way" : "Sent to your wallet"}</h1>
    <p className="muted" style={{ margin: "8px 6px 0", textAlign: "center", fontSize: "14px", lineHeight: "21px" }}>
      {sending
        ? "Usually about a minute. You can leave this screen, it arrives either way."
        : w.state === "partial"
          ? "Part of it arrived. The rest is back in your battle balance, and you can withdraw it again."
          : `It's already in ${walletName(view?.wallet?.appName)}. Come back anytime, your rank and badges wait for you.`}
    </p>
    <div className="g" style={{ marginTop: fit(12, 20), borderRadius: "20px", padding: "4px 0" }}>
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>To</span><span style={{ fontSize: "13px" }}><span className="mono">{w ? `${w.toWallet.slice(0, 4)}...${w.toWallet.slice(-4)}` : "..."}</span></span></div>
      <div className="div" style={{ margin: "0 14px" }}></div>
      <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Network fee</span><span style={{ fontSize: "13px" }}><span className="mono">{w?.fee ?? "0.10"} USDT</span></span></div>
      {secs !== null && <>
        <div className="div" style={{ margin: "0 14px" }}></div>
        <div className="li"><span className="muted" style={{ flex: "1", fontSize: "13px" }}>Arrived</span><span style={{ fontSize: "13px" }}><span className="mono">{new Date(w!.finishedAt!).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })} · {secs} seconds</span></span></div>
      </>}
    </div>
    <div style={{ marginTop: "auto", paddingTop: "12px", display: "flex", flexDirection: "column", gap: "10px" }}>
      <button onClick={() => go("App28", true)} className="btnP" style={{ border: "0", cursor: "pointer" }}>DONE</button>
      {w?.tx && <button onClick={() => open(explorerTx(w.tx!, view))} className="btnS" style={{ cursor: "pointer" }}>View on Tonviewer</button>}
    </div>
  </div>
</div>
    </>
  );
}
